import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const KEY = "vp_cart";
const ID_KEY = "vp_cart_id";

const load = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
};

const newCartId = () => crypto.randomUUID().replace(/-/g, "");

export function CartProvider({ children }) {
  const [items, setItems] = useState(load);
  const [cartId, setCartId] = useState(() => localStorage.getItem(ID_KEY) || "");

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  useEffect(() => {
    if (!cartId) {
      const id = newCartId();
      localStorage.setItem(ID_KEY, id);
      setCartId(id);
    }
  }, [cartId]);

  const addItem = (item) => setItems((cur) => [...cur, { ...item, uid: crypto.randomUUID() }]);
  const removeItem = (uid) => setItems((cur) => cur.filter((i) => i.uid !== uid));
  const updateItem = (uid, patch) => setItems((cur) => cur.map((i) => (i.uid === uid ? { ...i, ...patch } : i)));
  const clearCart = () => {
    setItems([]);
    const id = newCartId();
    localStorage.setItem(ID_KEY, id);
    setCartId(id);
  };

  return (
    <CartCtx.Provider value={{ items, cartId, addItem, removeItem, updateItem, clearCart, count: items.length }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
